import moment from "moment";
import { forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function DateInput({
  containerClassName,
  className,
  label,
  message,
  left,
  ...props
}) {
  return (
    <div className={containerClassName}>
      {label && (
        <label className="text-black-200 font-semibold text-sm mb-1 block">
          {label}
        </label>
      )}
      <div className="h-11 border border-white-300 w-full flex items-center rounded-sm bg-white-100 transition-colors focus-within:border-primary-500 focus-within:ring-2 focus-within:ring-primary-100">
        {left && <div className="ml-3 mr-1 text-black-400">{left}</div>}
        <DatePicker
          dateFormat="dd/MM/yyyy"
          className="h-full px-3 rounded-sm focus:outline-none w-full bg-transparent"
          {...props}
        />
      </div>
      {message && (
        <span className="text-red-300 text-sm mt-1 block">{message}</span>
      )}
    </div>
  );
}
